/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/shipping-and-fulfillment/fulfillmentservice
 * API Version: 2022-01
 */

import { GadgetSystemDominionId } from "../../database/DominionLiterals";
import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDraftOrderLineItemKey,
  ShopifyDraftOrderLineItemToFulfillmentServiceKey,
  ShopifyFulfillmentServiceKey,
  ShopifyFulfillmentServiceToDraftOrderLineItemsKey,
  ShopifyFulfillmentServiceToLocationKey,
  ShopifyFulfillmentServiceToShippingLinesKey,
  ShopifyFulfillmentServiceToShopKey,
  ShopifyLocationKey,
  ShopifyShippingLineKey,
  ShopifyShippingLineToFulfillmentServiceKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyFulfillmentServiceKey,
  defaultFilterableApiIdentifiers: ["adminGraphqlApiId"],
  "2022-01": {
    name: "Shopify Fulfillment Service",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Callback URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "callback_url" } },
      },
      {
        name: "Format",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "format" } },
      },
      {
        name: "Fulfillment Orders Opt In",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfillment_orders_opt_in" } },
      },
      {
        name: "Handle",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "handle" } },
      },
      {
        name: "Inventory Management",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "inventory_management" } },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentServiceToLocationKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "location_id" } },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Requires Shipping Method",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "requires_shipping_method" } },
      },
      {
        name: "Shipping Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentServiceToShippingLinesKey,
        configuration: {
          relatedModelKey: ShopifyShippingLineKey,
          inverseFieldKey: ShopifyShippingLineToFulfillmentServiceKey,
        },
      },
      {
        name: "Tracking Support",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tracking_support" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentServiceToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "fulfillmentService" },
  },
  "2022-07": {
    fields: [
      {
        name: "Permits SKU Sharing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "permits_sku_sharing" } },
      },
    ],
  },
  "2023-10": {
    fields: [
      {
        name: "Requires Shipping Method",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "requires_shipping_method", deprecated: true } },
      },
      {
        name: "Service Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_service_name",
            graphQLOnlyField: true,
            graphQLFieldKey: "serviceName",
          },
        },
      },
      {
        name: "Type",
        fieldType: FieldType.Enum,
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "GIFT_CARD" }, { name: "MANUAL" }, { name: "THIRD_PARTY" }],
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_type",
            graphQLOnlyField: true,
            graphQLFieldKey: "type",
          },
        },
      },
      {
        name: "Shipping Methods",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_shipping_methods",
            graphQLOnlyField: true,
            graphQLFieldKey: "shippingMethods",
            graphQLSelection: `
            code
            label
            `,
            deprecated: true,
          },
        },
      },
    ],
  },
  "2024-04": {
    fields: [
      {
        name: "Fulfillment Orders Opt In",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "fulfillment_orders_opt_in", deprecated: true } },
      },
    ],
  },
  "2024-07": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        key: `${ShopifyFulfillmentServiceKey}-system-id`,
        dominionID: GadgetSystemDominionId,
      },
      {
        name: "Admin GraphQL API ID",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "admin_graphql_api_id", graphQLFieldKey: "id" } },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "name", graphQLFieldKey: "name", skipGraphQLSelection: true },
        },
      },
      {
        name: "Handle",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "handle", graphQLFieldKey: "handle" } },
      },
      {
        name: "Callback URL",
        fieldType: FieldType.URL,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "callback_url", graphQLFieldKey: "callbackUrl" } },
      },
      {
        name: "Inventory Management",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "inventory_management", graphQLFieldKey: "inventoryManagement" },
        },
      },
      {
        name: "Location",
        fieldType: FieldType.BelongsTo,
        key: ShopifyFulfillmentServiceToLocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "location_id", graphQLFieldKey: "location", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyLocationKey,
        },
      },
      {
        name: "Shipping Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentServiceToShippingLinesKey,
        configuration: {
          relatedModelKey: ShopifyShippingLineKey,
          inverseFieldKey: ShopifyShippingLineToFulfillmentServiceKey,
        },
      },
      {
        name: "Tracking Support",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tracking_support", graphQLFieldKey: "trackingSupport" } },
      },
      {
        name: "Permits SKU Sharing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "permits_sku_sharing", graphQLFieldKey: "permitsSkuSharing" },
        },
      },
      {
        name: "Requires Shipping Method",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "requires_shipping_method", deprecated: true } },
      },
      {
        name: "Draft Order Line Item",
        fieldType: FieldType.HasMany,
        key: ShopifyFulfillmentServiceToDraftOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderLineItemKey,
          inverseFieldKey: ShopifyDraftOrderLineItemToFulfillmentServiceKey,
        },
      },
    ],
    syncConfig: { type: "custom", resource: "fulfillmentService", order: "first" },
  },
  "2024-10": {
    fields: [
      {
        name: "Shipping Methods",
        fieldType: FieldType.JSON,
        isDeleted: true,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_shipping_methods",
          },
        },
      },
    ],
  },
};

export const ShopifyFulfillmentService = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
